import type { ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

const ITEMS: { term: ReactNode; description: string }[] = [
  {
    term: <span className="font-mono text-ink">12.23</span>,
    description:
      'Value saved on the product. Enter or leave the field to save, Escape to discard; comma and dot both work.',
  },
  {
    term: <span className="text-mute">from variants / grey value</span>,
    description:
      'The product has no value of its own; the field shows what the variants carry or the base price of the method. Typing a value sets a product value or override.',
  },
  {
    term: <span className="text-mute">varies</span>,
    description:
      'Variants carry different values; hover for the range. Open the sizes to see them.',
  },
  {
    term: <span className="text-warning">missing / no price</span>,
    description:
      'Nothing is set anywhere, so sellers cannot be quoted. Orange on a method means neither a base price nor an override exists on the chosen platform.',
  },
  {
    term: <span className="font-mono text-warning">999.99</span>,
    description:
      'Import placeholder, not a real price. Counted as missing in the summary.',
  },
  {
    term: <span className="text-mute">n sizes have own price</span>,
    description:
      'Every sellable variant carries its own blank cost; the product value is kept but not used for the seller cost.',
  },
  {
    term: (
      <span className="inline-flex items-center gap-1 text-warning">
        <AlertTriangle className="h-3.5 w-3.5" aria-hidden="true" />
        product
      </span>
    ),
    description:
      'No offered method of the product has a price on the chosen platform.',
  },
  {
    term: <span className="text-mute">unknown</span>,
    description:
      'Seller cost cannot be computed; the reason is shown under it. It is never shown as 0.00.',
  },
];

/** Reading aid under the price table (R14). */
export function PriceLegend() {
  return (
    <section
      aria-label="Legend"
      className="rounded-card bg-paper-2 px-4 py-3 ring-1 ring-line"
    >
      <h2 className="dc-eyebrow mb-2">Legend</h2>
      <dl className="grid gap-x-6 gap-y-2 text-xs sm:grid-cols-2">
        {ITEMS.map((item, index) => (
          <div key={index} className="flex gap-2">
            <dt className="w-40 shrink-0">{item.term}</dt>
            <dd className="text-ink-2">{item.description}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
